module.exports = __webpack_public_path__ + "static/media/7.15.49c9b6b5.png";